<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        <v-row>
          <v-col cols="12">
            <div class="text-h2 text-primary mb-0">
              Relatórios / Concessionárias
            </div>
          </v-col>
          <v-col cols="11" class="pt-0">
            <v-row no-gutters>
              <v-col cols="2">
                <v-text-field
                  clearable
                  hide-details=""
                  clear-icon="close"
                  v-model="search"
                  outlined
                  label="Busca"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  class="ml-3"
                  :menu-props="{ offsetY: true}"
                  :items="estados"
                  label="Estado"
                  append-icon="expand_more"
                  v-model="estado"
                  hide-details=""
                  :loading="loading || loadingEstados"
                  :disabled="loading || loadingEstados"
                  outlined
                  clearable
                  clear-icon="close"
                  @change="filterCidade()"
                ></v-autocomplete>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  class="ml-3"
                  :menu-props="{ offsetY: true}"
                  :items="cidadesFiltro"
                  label="Cidade"
                  append-icon="expand_more"
                  v-model="cidade"
                  hide-details=""
                  :loading="loading || loadingCidades"
                  :disabled="loading || loadingCidades"
                  outlined
                  clearable
                  clear-icon="close"
                ></v-autocomplete>
              </v-col>
              <v-col cols="1">
                <div class="ml-3 search_btn">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="ui-btn-inherit ui-search_btn" v-bind="attrs" v-on="on" :loading="loadingSearch" :disabled="loadingSearch" @click="applyFilter()">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </template>
                    <span>Filtrar</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" class="pt-0 text-center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit mt-1" v-bind="attrs" v-on="on" @click="print()">
                  <v-icon large color="primary">
                    print
                  </v-icon>
                </v-btn>
              </template>
              <span>Imprimir relatório</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <div id="print" v-if="dados && dados.length > 0">
        <div class="impressao__header text-center">
          <img v-if="!user.logo_sistema" class="impressao__logo" src="@assets/img/logo.png" alt="SolarMaker">
          <img v-else class="impressao__logo" :src="user.logo_sistema" alt="Logo sistema">
          <p>Relatório de Concessionárias</p>
        </div>
        <div class="mb-3">
          <div class="text-h3 text-primary mb-2">
            <!-- {{itemPai.int_nome}} -->
          </div>
          <v-simple-table class="base_table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Nome
                  </th>
                  <th class="text-center">
                    CNPJ
                  </th>
                  <th class="text-center">
                    Estado
                  </th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in dados" :key="index">
                <tr>
                  <td class="text-left">
                    {{item.con_nome}}
                  </td>
                  <td class="text-center">
                    {{item.con_cnpj}}
                  </td>
                  <td class="text-center">
                    {{item.con_uf}}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div v-else>
        Nenhum dado encontrado.
      </div>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import axios from 'axios'
import Printd from 'printd'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
  components: {
    VueCtkDateTimePicker
  },
  data () {
    return {
      user: null,
      search: '',
      loading: true,
      loadingSearch: false,
      estados: [],
      cidades: [],
      cidadesFiltro: [],
      cidade: null,
      estado: null,
      cidadesFiltradas: [],
      loadingEstados: false,
      loadingCidades: false,
      dados: [
        {
          nome: ''
        }
      ],
      de: moment().startOf('month').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ]
    }
  },
  methods: {
    async print () {
      const d = new Printd()
      let styles = [
        `
          body {
            overflow: hidden;
            font-family: "Arial", sans-serif !important;
          }
          p, strong, b, small, span, q, i, td {
            color: #000!important;
            font-size: .85rem!important;
            line-height: .9rem!important;
            word-break: keep-all!important;
          }
          .v-application {
            font-family: "Arial", sans-serif !important;
          }
        `,
        `
          .impressao__header {
            width: 100%;
            text-align: center;
            color: #000!important;
          }
          .impressao__header p {
            margin-top: 1em;
            font-size: 14px;
            font-weight: bold;
          }
          .impressao__logo {
            max-width: 20%;
            color: #000!important;
          }
          .impressao__footer {
            bottom: 0;
            position: fixed;
            width: 100%;
            display: none;
          }
          .impressao__footer_text {
            text-align: center;
            color: #d0d0d0;
            font-size: 11px;
            padding-top: 5px;
          }
          .impressao__footer_hr {
            margin-bottom: 10px;
          }
          .impressao__break {
            page-break-after: always;
          }
          .impressao__footer, .impressao__footer-space {
            height: 2em;
          }
          #print .text-h3 {
            font-weight: bold;
            font-size: 13px;
            margin-top: 3em;
          }
          @media screen {
            .impressao__footer {
              display: none;
            }
          }
          @media print {
            thead {display: table-header-group;}
            tfoot {display: table-footer-group;}
            button {display: none;}
            body {margin: 0;}
            * {
              color: #000!important;
            }
            .v-data-table th {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              min-width: 4em;
            }
            .v-data-table td {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              max-width: 20em;
            }
            .v-data-table .text-center {
              text-align: center;
            }
            p {
              widows: 3;
            }

            .impressao__footer {
              display: block;
            }
            .impressao__header {
              display: block;
              width: 100%;
              color: #000!important;
            }
          }
          @page {
            size: A4 !important;
            margin: 12mm;
          }
        `,
        'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
        'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
      ]

      let documento = document.getElementById('print')
      await d.print(documento, styles)
    },
    applyFilter () {
      this.loading = true
      this.loadingSearch = true
      let query = Object.assign({},
        this.search ? { busca: this.search } : '',
        this.estado ? { estado: this.estado } : '',
        this.cidade ? { cidade: this.cidade } : ''
      )
      this.$router.replace({name: 'RelatoriosConcessionarias', query: query}).catch(() => {})

      this.getDados()
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.estado) this.estado = filters.estado
      if (filters.cidade) this.cidade = filters.cidade
      if (filters.busca) {
        this.search = filters.busca
      }
      this.getEstados()
      this.getCidade()
      this.getDados()
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
          if (this.estado) {
            this.cidadesFiltro = this.cidades.filter(city => city.uf === this.estado)
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    filterCidade () {
      this.cidade = null
      this.cidadesFiltro = this.cidades.filter(city => city.uf === this.estado)
    },
    async getDados () {
      this.loading = true
      let endpoint = '?filtro='
      if (this.search) {
        endpoint += `&busca=${this.search}`
      }
      if (this.estado) {
        endpoint += `&estado=${this.estado}`
      }
      if (this.cidade) {
        endpoint += `&cidade=${this.cidade}`
      }

      await Api.get('relatorios/concessionarias' + endpoint)
        .then(res => {
          this.dados = res.data
          this.loading = false
          this.loadingSearch = false
        })
        .catch(err => {
          this.loading = false
          this.loadingSearch = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os relatórios de concessionárias!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item_lista {
  border: 1px $primary solid;
  border-left-width: 10px;
  height: 100%;
  padding: 15px;
  .text-h3 {
    margin-bottom: 25px;
    position: relative;
    &:before {
      background: $primary;
      bottom: -10px;
      content: '';
      height: 1px;
      left: -15px;
      position: absolute;
      width: calc(100% + 30px);
    }
  }
  @media (max-width: 767px){}
}
.impressao__header {
  width: 100%;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/operacional/Concessionarias.vue